import * as React from 'react';
const ReactMarkdown = require('react-markdown');
import './markdownText.module.scss';

type Props = {
  source: string;
};

export class MarkdownText extends React.Component<Props> {
  render() {
    const { source } = this.props;
    return (
      <div styleName="markdown-text">
        <ReactMarkdown source={source} />
      </div>
    );
  }
}
